import React, { Suspense } from 'react';
import { ErrorBoundary, createLogger } from '../../errorLogging';

const SidePanel = React.lazy(() =>
  import(/* webpackChunkName: "sidepanel" */ './SidePanel'),
);

const logger = createLogger('SidePanel');

export function SidePanelContainer() {
  const fallback = null;

  return (
    <Suspense fallback={fallback}>
      <ErrorBoundary logger={logger} fallback={fallback}>
        <SidePanel />
      </ErrorBoundary>
    </Suspense>
  );
}
